import { render } from "./tipodocumento.vue?vue&type=template&id=64711682"
import script from "./tipodocumento.vue?vue&type=script&lang=js"
export * from "./tipodocumento.vue?vue&type=script&lang=js"

import "./tipodocumento.vue?vue&type=style&index=0&id=64711682&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__